// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1GZTo","communityStat":"styles-module__communityStat___ufJ4M"};